import { Form, BaseModel, OneColumnLayout, Entry, EntryTypes, CardMode, Resource } from '@ngx-resource-toolkit/core';
import { ExamenMentionModel } from './examen-mention.model';
import { environment } from '../../../../environments/environment';
import { LeaResource } from '../../resource/lea.resource';

const cssLabel = 'col-xs-5';
const normalCss = {
    group: 'col-xs-12',
    label: cssLabel,
    input: 'col-xs-7'
};

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/examen',
            methods: LeaResource.methods
        }
    }
})
@Form({
    'consult': { // Mode consultation
        layout: OneColumnLayout,
    },
    'edit': { // Mode modification (création/modification)
        layout: OneColumnLayout,
    }
})
export class ExamenResultatJuryModel extends BaseModel {

    idExamenResultat: number;

    @Entry({
        base: {
            label: 'Libellé Jury',
            css: normalCss,
            type: EntryTypes.STATIC,
        },
        'consult': {
            type: EntryTypes.STATIC,
        },
        'edit': {
            type: EntryTypes.TEXT,
        },
    })
    libelle: string;

    @Entry({
        base: {
            label: 'Mention jury',
            css: normalCss,
            // transform: (value, row) => 'mention test',
        },
        'consult': {
            type: EntryTypes.STATIC,
            transform: (value, row) => row.mentionLibelle ? row.mentionLibelle : '',
        },
        'edit': {
            nested: true,
        },
    })
    mention: ExamenMentionModel;
    mentionId: number;

    @Entry({
        base: {
            label: 'Commentaires jury',
            css: normalCss,
        },
        'consult': {
            type: EntryTypes.STATIC,
        },
        'edit': {
            type: EntryTypes.TEXTAREA,
        },
    })
    commentaire: string;

    // Attributs ajoutés en lecture pour faciliter l'affichage de l'information
    mentionLibelle: string;

    constructor(data = null, examen?, typeNotation?, isInitModele = true, isInitData = true, parent?: any) { // fields: any, typeNotation: any, examen: any
        super();
        if (isInitModele) {
            this.initModele(typeNotation, examen, data, parent);
        }
        if (isInitData) {
            this.initData(data);
        }
		/*this.initData(fields);
		this.initModele(typeNotation, examen, fields);*/
    }

    initData(fields: any) {
        // console.log({ ou: 'ExamenResultatJuryModel.initData', fields});
        if (fields) {
            // Affectation faite champ par champ au lieu de (Object.assign(this, fields);) car sinon afecte l'id de la mention à la place de l'objet mention
            this.libelle = fields.libelle;
            // Mentionb : nécessite d'avoir la liste des mentions contenu dans typeNotation ?
            // this.mention = new ExamenMentionModel();
            // Attention l'id de la mention est initialisé en même temps que le modele dans initModele
            if (this.mentionId) {
                // console.log({ idMentionASelectionner: this.mentionId, mention: this.mention, mentionProperty: 'todo'});
                this.mention.registerEntryDynamicProperty(['edit'], 'id', 'default', +this.mentionId);
            }
            this.commentaire = fields.commentaire;
            this.mentionLibelle = fields.mentionLibelle;
        }
        // console.log('ExamenResultatJuryModel.initData objets assignés');
        const nomChampMention = 'mention';
        // this[nomChampMention].initData();
    }
    initModele(typeNotation: any, examen: any, fields?: any, parent?: any) {
        // console.log({ ou: 'ExamenResultatJuryModel.initModele', typeNotation, juryMention: examen.juryMention, fields });
        // Mention du jury
        const nomChampMention = 'mention';
        if (examen.juryMention && +examen.juryMention > 0) {
            let libelleMention = '';
            if (fields) {
                libelleMention = fields['mentionLibelle'];
            } else {
                libelleMention = 'Mention';
            }
            const mentionModele = new ExamenMentionModel(); // fields[nomChampMention], -2, typeNotation, nomChampMention, libelleMention, examen.juryMention
            // fields: any, indexNoteMention: number, typeNotation: any, nomChampMention: string, libelleMention?: string, groupeMention?: number
            mentionModele.initModele(-2, typeNotation, nomChampMention, libelleMention, this, +examen.juryMention);
            this.mentionId = fields ? +fields.mention : undefined; // mention contient l'id de la mention sélectionnée à l'origine
            this[nomChampMention] = mentionModele;
            /*this.mention = 'test mention';//mentionModele;
            const entryMentionCouranteEdit = this.getEntry('edit', nomChampMention);
            const entryMentionCouranteConsult = this.getEntry('consult', nomChampMention);
            entryMentionCouranteConsult.hidden = false;
            entryMentionCouranteEdit.hidden = false;
            */
            /*if (parent) {
                const entryEdit = parent.getEntry('edit', 'resultatJury');
                const entryConsult = parent.getEntry('consult', 'resultatJury');
                parent.registerEntryDynamicProperty(['edit', 'consult'], 'resultatJury', this);
            }*/
        }
        // console.log({ ou: 'ExamenResultatJuryModel.initModele', resultatjury: this });
    }
}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/examen/models/examen-resultat-jury.model.ts